"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInputContent = void 0;
exports.SearchInputContent = {
  en: {
    placeholderText: "Search"
  },
  fr: {
    placeholderText: "Chercher"
  },
  es: {
    placeholderText: "Búsqueda"
  }
};